// Region configuration (SPEC §2): data base URL and per-region display info.

import { fetchJson } from './http';

export interface RegionInfo { id: string; obcina: string; center?: [number, number] } // center = lon, lat

const KNOWN: Record<string, RegionInfo> = {
  sentjur: { id: 'sentjur', obcina: 'Šentjur', center: [15.40, 46.22] },
};

const env = (import.meta as any).env ?? {};
const proc = (globalThis as any).process?.env ?? {};

let base: string = String(env.VITE_DATA_BASE ?? proc.VITE_DATA_BASE ?? '/devdata').replace(/\/$/, '');
export const dataBase = () => base;
/** Override the data host (tests, scripts). */
export function setDataBase(url: string) { base = url.replace(/\/$/, ''); }
export const REGIONS: RegionInfo[] = String(env.VITE_REGIONS ?? proc.VITE_REGIONS ?? 'sentjur')
  .split(',').map((s) => s.trim()).filter(Boolean).map((id) => KNOWN[id] ?? { id, obcina: id });

export function regionUrl(region: string, path: string, override?: string): string {
  const root = override ?? base;
  const b = /^https?:/.test(root) ? root : new URL(root, globalThis.location?.href ?? 'http://localhost/').href.replace(/\/$/, '');
  return `${b}/${region}/${path}`;
}

export interface DataVersion { version?: string; cadastre_date?: string; [k: string]: unknown }

/** Optional `version.json` in the region folder (SPEC §8.1). */
export async function dataVersion(region: string): Promise<DataVersion | null> {
  try { return await fetchJson<DataVersion>(regionUrl(region, 'version.json')); } catch { return null; }
}
